import Telegram from './Telegram'

export default Telegram
// eslint-disable-next-line import/export
export * from './Telegram'
